<app-page-title pageTitle="EAUTHORISATION-OVERVIEW.SUPPORT.TITLE"></app-page-title>

<div class="assign-overview-container section-p">
    <div class="main-box-style">
        <div class="steps-container">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
                <address>
                    <strong>{{ "EAUTHORISATION-OVERVIEW.SUPPORT.MAIL-TEXT" | translate }}</strong>
                    <a
                    class="text-primary font-weight-bold"
                    href="mailto:{{ 'EAUTHORISATION-OVERVIEW.SUPPORT.MAIL' | translate }}"
                    >
                    {{ "EAUTHORISATION-OVERVIEW.SUPPORT.MAIL" | translate }}</a
                    ><br />
                    <strong>{{ "EAUTHORISATION-OVERVIEW.SUPPORT.TELEPHONE" | translate }}</strong>
                    <a
                    class="text-primary font-weight-bold"
                    href="{{ 'EAUTHORISATION-OVERVIEW.SUPPORT.TELEPHONE-HREF' | translate }}"
                    >
                    {{ "EAUTHORISATION-OVERVIEW.SUPPORT.TELEPHONE-NUM" | translate }}</a
                    >
                </address>
                <!-- <address>
                    <strong>{{ "EAUTHORISATION-OVERVIEW.SUPPORT.AKD-MAIL-TEXT" | translate }}</strong>
                    <a
                    class="text-primary font-weight-bold"
                    href="mailto:{{ 'EAUTHORISATION-OVERVIEW.SUPPORT.AKD-MAIL' | translate }}"
                    >
                    {{ "EAUTHORISATION-OVERVIEW.SUPPORT.AKD-MAIL" | translate }}</a
                    ><br />
                    <strong>{{ "EAUTHORISATION-OVERVIEW.SUPPORT.AKD-TELEPHONE" | translate }}</strong>
                    <a
                    class="text-primary font-weight-bold"
                    href="{{ 'EAUTHORISATION-OVERVIEW.SUPPORT.AKD-TELEPHONE-HREF' | translate }}"
                    >
                    {{ "EAUTHORISATION-OVERVIEW.SUPPORT.AKD-TELEPHONE-NUM" | translate }}</a
                    >
                </address> -->
                <p>
                    {{ "EAUTHORISATION-OVERVIEW.SUPPORT.WORKING-TIME" | translate }}
                </p>
                </div>
            </div>
            </div>

        </div>
    </div>

